
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M9.85 25.79v7.89M13.8 29.73H5.9"}}),_c('circle',{attrs:{"cx":"33.58","cy":"30.03","r":"1.52","fill":"#241f21"}}),_c('circle',{attrs:{"cx":"26.87","cy":"30.03","r":"1.52","fill":"#241f21"}}),_c('circle',{attrs:{"cx":"30.23","cy":"26.67","r":"1.52","fill":"#241f21"}}),_c('circle',{attrs:{"cx":"30.23","cy":"33.38","r":"1.52","fill":"#241f21"}}),_c('path',{attrs:{"d":"M30.15 21.39H9.85a8.6 8.6 0 107.72 12.39h4.86a8.6 8.6 0 107.72-12.39zM18.04 27.72h3.92M24.93 21.05a4.93 4.93 0 10-9.86 0","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"d":"M20.05 16V8.48a4.51 4.51 0 019 0 2.51 2.51 0 005 0V0","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}})])
          )
        }
      }
    